module.exports = __webpack_public_path__ + "img/glogo.1cdc8fce.svg";